import { SUBSCRIPTION_LABEL_STATE, SUBSCRIPTION_LABEL_TIER } from './constants'

const { FREE, YOURS, UPGRADE } = SUBSCRIPTION_LABEL_STATE
const { ESSENTIALS, PREMIUM } = SUBSCRIPTION_LABEL_TIER

// A Premium subscriber always sees their Premium entitlement; the Premium offer (free / upgrade)
// stays behind the premiumExposed buyer-surface gate.
export default function resolveLabelState({ tierBand, subscriberTier = null, premiumExposed = false }) {
  if (tierBand === ESSENTIALS) {
    return subscriberTier === ESSENTIALS || subscriberTier === PREMIUM ? YOURS : FREE
  }

  if (tierBand === PREMIUM) {
    if (subscriberTier === PREMIUM) return YOURS
    if (!premiumExposed) return null
    return subscriberTier === ESSENTIALS ? UPGRADE : FREE
  }

  return null
}
